import React from 'react';

import MainLayout from '../components/layouts/MainLayout';
import LandingMenuHub from '../components/menu/landing/LandingMenuHub';


export default function Home({ pageContext }) {

    return(
        <MainLayout>
                <LandingMenuHub prerenderdata={pageContext}/>
        </MainLayout>
    )
}